import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, MissionPageContainer } from "../../common_components/Layout";
import SubHeader from "../SubHeader";
import { SessionHighlightUpcoming } from "../../common_components/SessionHighlights";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";


// Api Calls
import ScheduledEventAPI from "../../../api/api_calls/ScheduledEventAPI";


function UpcomingSessions(props) {
    // So we'll 

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [loadingEvents, setLoadingEvents] = useState(true);
    const [upcomingEvents, setUpcomingEvents] = useState([]);
    const [timezone, setTimezone] = useState("");




    useEffect(() => {
        async function getUpcomingSessionsAndStats() {
            const result = await ScheduledEventAPI.one_mission_upcoming_events_and_stats(missionId, navigate);

            if (result.success) {
                setUpcomingEvents(result.upcoming_events)
                setTimezone(result.timezone)
                setLoadingEvents(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        getUpcomingSessionsAndStats();
    }, []);

    const upcomingSessionComponents = loadingEvents ? <CenteredLoadingIcon />
        :
        upcomingEvents.length === 0 ? <div className="white-text">No upcoming sessions.</div>
            :
            upcomingEvents.map((event, index) => {
                return (
                    <SessionHighlightUpcoming key={index} session={event} timezone={timezone} onClick={() => navigate("/missions/" + missionId + "/sessions/" + event.id)} />
                )
            })


    return (
        <>
            <SubHeader title={"Upcoming Sessions"} backText="Back to Project" navigateBack={() => navigate("/missions/" + missionId)} />
            <MissionPageContainer>
                <Card >
                    <GrayCardTitle title="Sessions" />
                    <div className="upcoming-sessions-container">
                        {upcomingSessionComponents}
                    </div>
                </Card>
            </MissionPageContainer>
        </>

    )

}

export default UpcomingSessions;